module.exports = __webpack_public_path__ + "img/top-round-steak-for-grill.707576c9.jpg";